import { StyleObjectIdentifier, StyleObjectRules } from "@tamagui/helpers";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function wrapStyleTags(styles, content) {
  return process.env.TAMAGUI_REACT_19 && styles.length ? /* @__PURE__ */jsxs(Fragment, {
    children: [content, styles.map(styleObject => {
      const identifier = styleObject[StyleObjectIdentifier];
      return /* @__PURE__ */jsx("style", {
        href: `t_${identifier}`,
        precedence: "default",
        children: styleObject[StyleObjectRules].join(`
`)
      }, identifier);
    })]
  }) : content;
}
export { wrapStyleTags };
//# sourceMappingURL=wrapStyleTags.mjs.map
